import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Text } from 'core/components';
import { Field, FormDialog, InputGroup } from 'core/form';
import agentConfigFields from 'app/forms/config/synthetics/fields/agentConfigFields';
import AgentConfigForm from './AgentConfigForm';

const options = {
  name: 'Synthetic Agent Config'
};

@inject('$labels', '$syn', '$sites', '$notifications')
@observer
export default class AgentConfigFormDialog extends Component {
  state = { challengeModel: null };

  constructor(props) {
    super(props);

    const { model } = props;

    if (model) {
      model.setNotificationChannels();
    }
  }

  get fields() {
    const { universalAgentModel } = this.props;
    return agentConfigFields(universalAgentModel);
  }

  handleSave = (form, values) => {
    const { $labels, $sites, $notifications, onSave } = this.props;
    const { model } = form;

    // Anything saved will be "activated" in the process
    values.agent_status = 'OK';

    return model.save(values, { sudoMode: !!form.sudoMode }).then(() => {
      $labels.labels.fetch({ force: true });
      $sites.collection.fetch({ force: true });
      $notifications.collection.fetch({ force: true });
      if (onSave) {
        onSave();
      }
    });
  };

  handleChallenge = (form, { challenge }) => {
    const { $syn, agentMetadata, onChallenge } = this.props;
    return $syn.agents.findAgentByChallenge(challenge, agentMetadata).then((challengeModel) => {
      this.setState({ challengeModel });

      if (onChallenge) {
        onChallenge(challengeModel);
      }

      return false;
    });
  };

  render() {
    const { universalAgentModel, onClose, challenge, model, onSave, ...rest } = this.props;
    const { challengeModel } = this.state;

    const formModel = challengeModel || model;
    const challengeMode = challenge && !formModel;

    let title = 'Register Agent';
    let submitButtonText = 'Register';
    let closeAfterSave = false;

    if (formModel) {
      closeAfterSave = true;
      title = 'Configure Agent';
      submitButtonText = 'Save';

      if (formModel.get('agent_status') === 'WAIT') {
        title = 'Activate Agent';
        submitButtonText = 'Activate';
      }
    }

    return (
      <FormDialog
        {...rest}
        model={challengeModel || model}
        fields={this.fields}
        options={options}
        title={title}
        entityName="Agent"
        isOpen
        onClose={onClose}
        formActionsProps={{
          onSubmit: challengeMode ? this.handleChallenge : this.handleSave,
          onCancel: onClose,
          submitButtonText,
          closeAfterSave
        }}
        width={500}
      >
        {challengeMode && (
          <>
            <Text small muted as="div" mb={1}>
              Enter the challenge code shown by your agent:
            </Text>
            <Field name="challenge" fill large autoFocus>
              <InputGroup />
            </Field>
          </>
        )}
        {!challengeMode && <AgentConfigForm universalAgentModel={universalAgentModel} />}
      </FormDialog>
    );
  }
}
